import styled from 'styled-components';

export const Logo = styled.img`
  height: 32px;
  width: 32px;
  background-color: white;
  padding: 0.2rem;
  border-radius: 2rem;
`;
